import { Component, OnInit, Input } from '@angular/core';
import { MusicAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-music',
  templateUrl: './music.component.html',
  styleUrls: ['./music.component.scss']
})
export class MusicComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'music-item';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: MusicAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'music-item',
        title: 'Music',
        type: 'children',
        childType: 'music-item',
        plural: 'music items',
        singular: 'Music item',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
